import { render, staticRenderFns } from "./videoone.vue?vue&type=template&id=33b7077f&scoped=true&"
import script from "./videoone.vue?vue&type=script&lang=js&"
export * from "./videoone.vue?vue&type=script&lang=js&"
import style0 from "./videoone.vue?vue&type=style&index=0&id=33b7077f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b7077f",
  null
  
)

export default component.exports